import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { Badge, Button, Card, CardHeader, Col, Progress, Row, Table } from 'reactstrap'
import { useFetch } from '../../hooks'
import { api } from '../../utils'
import Header from '../../components/Headers/Header'
import { all, create } from 'mathjs'
import { notify } from '../../utils/notify'


const math = create(all)

const CategoryTextGenListing = () => {
  const history = useHistory()
  const itemPerPage = 10

  const [pages, setPages] = useState(0)
  const [tableData, setTableData] = useState([])
  const [actualPage, setActualPage] = useState(1)

  const { data, info, loading } = useFetch({
    url: 'category-text-gen/',
    params: { page_size: itemPerPage },
  })

  useEffect(() => {
    if (data.length > 0 && tableData.length === 0) {
      setTableData(data)
      setPages(Math.ceil(info.count / itemPerPage))
    }
  }, [data, info, tableData])

  const handlePageClick = (data) => {
    const currentPage = data.selected + 1
    setActualPage(currentPage)
    api
      .get('category-text-gen/', {
        params: {
          page_size: itemPerPage,
          page: currentPage,
        },
      })
      .then((response) => {
        setTableData(response.data.results)
        setPages(Math.ceil(response.data.count / itemPerPage))
      })
      .catch((error) => console.error(error))
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'COMPLETED':
      case 'READY_TO_EXPORT':
      case 'DONE':
        return 'success'
      case 'ERROR':
        return 'danger'
      case 'IN_PROGRESS':
      case 'PENDING':
        return 'primary'
      default:
        return 'warning'
    }
  }

  const handleSoftDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo job?')) {
      return
    }

    try {
      await api.post(`category-text-gen/${id}/soft-delete/`)
      setTableData((prev) => prev.filter((item) => item.id !== id))
      notify('Job eliminato con successo.', 'success')
    } catch (error) {
      notify(error?.response?.data?.error || 'Impossibile eliminare il job.', 'error')
    }
  }

  return (
    <Header
      iconClass="fa-solid fa-file-lines text-white"
      title="Generatore Testi per Categorie"
      description={"Genera descrizioni ottimizzate per la SEO per le pagine di categoria, analizzando i prodotti presenti sulla pagina."}
    >
      {loading && <div className="text-center"><Spinner animation="grow" /></div>}
      {tableData && (
        <Row style={{ marginBottom: '100px' }}>
          <div className="col pb-5">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h1 className="mb-0">Job di Generazione Testi</h1>
                  </Col>
                  <Col className="text-right" xs="4">
                    <Button
                      color="info"
                      onClick={() => history.push('/add-category-text-gen/')}
                      size="md"
                    >
                      + Nuovo Job
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Data</th>
                    <th scope="col">Progresso</th>
                    <th scope="col">Status</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((item) => (
                    <tr key={item.id}>
                      <th scope="row">
                        <Link to={`/add-category-text-gen/${item.id}`}>{item.name}</Link>
                      </th>
                      <td>{new Date(item.created).toLocaleDateString()}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div>
                            <Progress
                                max="100"
                                value={(math.evaluate(item.progress || '0/1') * 100).toString()}
                                barClassName={math.evaluate(item.progress || '0/1') === 1 ? "bg-success" : "bg-warning"}
                            />
                            {item.progress}
                          </div>
                        </div>
                      </td>
                      <td>
                        <Badge color={getStatusBadge(item.status)} pill className="text-white">
                          {item.status}
                        </Badge>
                      </td>
                      <td className="text-right">
                        {math.evaluate(item.progress || '0/1') === 1 && (
                            <a
                                href={`${api.defaults.baseURL}category-text-gen/${item.id}/download_excel/`}
                                download
                            >
                                <Button color="success" size="sm" title="Download Excel"><i className="fas fa-file-download" /></Button>
                            </a>
                        )}
                        <Button
                          color="danger"
                          size="sm"
                          className="ml-2"
                          onClick={() => handleSoftDelete(item.id)}
                        >
                          Elimina
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pages}
                forcePage={actualPage - 1}
                onPageChange={handlePageClick}
                containerClassName={'pagination justify-content-center pt-5 pb-3'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                activeClassName={'active'}
              />
            </Card>
          </div>
        </Row>
      )}
    </Header>
  )
}

export default CategoryTextGenListing
